import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReplaceIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Replace",
    children: /*#__PURE__*/_jsx("path", {
      d: "M5.52 19h7.03c.97 0 1.76.79 1.76 1.76v5.27c0 .97-.79 1.76-1.76 1.76H5.52c-.97 0-1.76-.79-1.76-1.76v-5.27c0-.97.79-1.76 1.76-1.76m8.56-14.79H7.46c-.97 0-1.76.79-1.76 1.76v4.92H2.91c-.5 0-.91.41-.91.91 0 .25.1.48.27.64l4.53 4.53c.16.17.39.27.64.27s.48-.1.64-.27l4.53-4.53c.16-.16.26-.39.26-.63 0-.5-.41-.91-.91-.91H9.22V7.73h4.86c.97 0 1.76-.79 1.76-1.76s-.79-1.76-1.76-1.76h-.03Zm5.37 0h7.03c.97 0 1.76.79 1.76 1.76v5.27c0 .97-.79 1.76-1.76 1.76h-7.03c-.97 0-1.76-.79-1.76-1.76V5.97c0-.97.79-1.76 1.76-1.76m10.28 15.35-4.53-4.53c-.16-.17-.39-.27-.64-.27s-.48.1-.64.27l-4.53 4.53c-.16.16-.26.39-.26.63 0 .5.41.91.91.91h2.74v3.17h-4.83c-.97 0-1.76.79-1.76 1.76s.79 1.76 1.76 1.76h6.62c.97 0 1.76-.79 1.76-1.76v-4.92h2.79c.5 0 .91-.41.91-.91 0-.25-.1-.48-.27-.64Z"
    })
  }));
};